"use client";
import React from "react";
import { Users } from "lucide-react";

export default function CustomersComingSoon() {
  return (
    <div className="flex items-center justify-center h-[80vh]">
      <div className="text-center">
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 bg-teal-600 rounded-xl flex items-center justify-center">
            <Users className="w-8 h-8 text-white" />
          </div>
        </div>

        <h1 className="text-3xl font-bold text-teal-800 mb-2">
          Customers Dashboard
        </h1>

        <p className="text-gray-600 text-lg">
          🚧 Dashboard Coming Soon
        </p>

        <p className="text-gray-500 mt-2">
          We're working on this feature.
        </p>
      </div>
    </div>
  );
}